import { render, staticRenderFns } from "./phoneProduct.vue?vue&type=template&id=15505ad9&scoped=true"
import script from "./phoneProduct.vue?vue&type=script&lang=js"
export * from "./phoneProduct.vue?vue&type=script&lang=js"
import style0 from "./phoneProduct.vue?vue&type=style&index=0&id=15505ad9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15505ad9",
  null
  
)

export default component.exports